import { DatabaseService, RepositoryHost } from "@/core";
import { getAuditLogRepository } from "./audit-log-repository";
import { getConfigRepository } from "./config-repository";
import { getCustomerMetricsRepository } from "./customer-metrics-repository";
import { getCustomerRepository } from "./customer-repository";
import { getDealRepository } from "./deal-repository";
import { getEventRepository } from "./event-repository";
import { getProductRepository } from "./product-repository";
import { getPromoCodeRepository } from "./promo-code-repository";
import { getTemporaryDealRepository } from "./temporary-deal-repository";
import { getUserRepository } from "./user-repository";

export const repositoryHost: RepositoryHost = {
      getConfigRepository: (databaseService: DatabaseService) =>
    getConfigRepository(databaseService),
getPromoCodeRepository: (databaseService: DatabaseService) =>
    getPromoCodeRepository(databaseService),
getUserRepository: (databaseService: DatabaseService) =>
    getUserRepository(databaseService),
  getProductRepository: (databaseService: DatabaseService) =>
    getProductRepository(databaseService),
  getEventRepository: (databaseService: DatabaseService) =>
    getEventRepository(databaseService),
  getDealRepository: (databaseService: DatabaseService) =>
    getDealRepository(databaseService),
  getCustomerMetricsRepository: (databaseService: DatabaseService) =>
    getCustomerMetricsRepository(databaseService),
  getAuditLogRepository: (databaseService: DatabaseService) =>
    getAuditLogRepository(databaseService),
  getTemporaryDealRepository: (databaseService: DatabaseService) =>
    getTemporaryDealRepository(databaseService),
  getCustomerRepository: (databaseService: DatabaseService) =>
    getCustomerRepository(databaseService),
};
